import { combineReducers } from "redux";
import { appReducer } from "./AppReducer";
import { toolbarReducer } from "./ToolbarReducer";

const rootReducer = combineReducers({ toolbar: toolbarReducer, app: appReducer });

export default rootReducer;